import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import React, {useCallback, useEffect, useState} from 'react';
import DATA_FILTERS from 'go/components/common/dataFilters';
import { ContentDispatch } from 'framework';

export const MergeDependencyListener = ({filterFunc, allowEmptyData, contents, ...props}) => {
  const isMergeDone = _.get(props, 'context.mergeListenerDone', false);
  const dependentList = _.map(props.dependentKeys, (key) => {
    return props[key] && props[key].loading ? false : true;
  });
  const isAllLoaded = (data) => _.find(data, (value) => value === false);
  const saveToContext = useCallback( async () => {
    const data = await DATA_FILTERS[filterFunc](props);
    if (data.length > 0 || allowEmptyData) {
      props.saveEntitySessionData(props.saveEntityDataPath, data);
      if (props.saveFilterIds) {
        const {idKey, contextPath} = props.saveFilterIds;
        const ids = _.orderBy(_.map(data, idKey));
        props.saveEntitySessionData(contextPath, ids);
      }
      props.saveEntitySessionData('context.mergeListenerDone', !isMergeDone);
    }
  }, [...dependentList, filterFunc, isMergeDone]);

  useEffect(() => {
    if (dependentList && !isAllLoaded(dependentList) && !isMergeDone) {
      saveToContext();
    }
  }, [...dependentList, filterFunc, isMergeDone]);

  return (
    <>
      {isMergeDone
        ? _.map(contents, (entry, index) => {
            return <ContentDispatch config={entry} key={entry.title}/>;
          })
        : null}
    </>
  );
};

export default connectDynamic(MergeDependencyListener);
